// App version + build constants для футера ProfileTab (Mini-sprint 6-profile).
// Source: docs/specs/sprint-6-profile/stage-4-frontend.md §2.
//
// Build-time inlining через vite:
//  - pkg.version из frontend/package.json (resolveJsonModule в tsconfig)
//  - VITE_CAP_BUILD_NUMBER из env (Codemagic подставляет в `Verify web bundle`
//    через `export ...` со fallback chain, см. codemagic.yaml + stage-5 §1.2)
//
// На web build (GitHub Actions deploy) env-var отсутствует → APP_BUILD = null →
// строка без «сборка». By design.

import pkg from '../../package.json';

const buildNumber = (import.meta.env.VITE_CAP_BUILD_NUMBER as string | undefined) ?? null;

function isCapacitorRuntime(): boolean {
  if (typeof window === 'undefined') return false;
  return Boolean((window as unknown as { Capacitor?: unknown }).Capacitor);
}

export const APP_VERSION = `v${pkg.version}`;
export const APP_BUILD: string | null =
  isCapacitorRuntime() && buildNumber ? `сборка ${buildNumber}` : null;
export const APP_VERSION_LINE = APP_BUILD
  ? `HealthLab ${APP_VERSION} · ${APP_BUILD}`
  : `HealthLab ${APP_VERSION}`;
